import React from 'react'

const PictureContainer = ({ className, children }) => {
  return(
    <div className={className}>
      {children}
    </div>
  )
}

export default PictureContainer